export default __webpack_public_path__ + "static/media/booking.4cbbb3e1.png";